module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/2-ls-82d8586c821e5dec8559184a87adeeb7.jpg";